import axios from 'axios';
// Wrap request object's methods so they will cancel previous
// requests if they are still sending
export default function cancelIfSending(methods) {
  const wrappedSource = {};
  Object.keys(methods).forEach(key => {
    const original = methods[key];
    const CancelToken = axios.CancelToken;
    let source = null;
    wrappedSource[key] = (...args) => {
      source && source.cancel();
      source = CancelToken.source();
      return original(...args, {
        cancelToken: source.token,
      }).then(response => {
        source = null;
        return response;
      });
    };
  });
  return wrappedSource;
}
